import React, { useEffect } from 'react';
import styleThankYou from './ThankYou.module.scss';
import Logo from '../../components/Logo/Logo';
import {Button} from 'antd';
import {useSelector, useDispatch} from 'react-redux';
import * as actionTypes from '../../redux/actions/actionTypes';
import {sendRemainderEmail} from '../../redux/actions/mock/invioDocumenti';
import {salvaCurrentStep} from '../../redux/actions/mock/salvaStep';
import { getCookie, trackCookie } from '../../redux/actions/mock/adtractionCookie';
import API from '../../redux/api/api';


const ThankYou = (props) => {

    const dispatch = useDispatch();
    const uuid = useSelector(state => state.dataReducer.modello.id);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    const risultato = props.risultato;
    const type = props.type;
    const linkHome = useSelector(state => state.dataReducer.documentiPdf.linkHome);
    const linkPreventivatore = useSelector(state => state.dataReducer.documentiPdf.linkPreventivatore);
    const loadingConferma = useSelector(state => state.dataReducer.load.loadingConferma);
    const numPratica = useSelector(state => state.dataReducer.modello.numPratica);

    useEffect(() => {
        handleCookie();
    }, []);

    async function handleCookie() {
        const cookieValue = await getCookie(apiPath);
        console.log({cookieValue});
        if (cookieValue) {
            trackCookie(numPratica, cookieValue);
        }
    }

    async function onSendRemainderEmail() {
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        // Salva lo step 15 sul backend senza aggiornare il frontend
        await API.getAxios(apiPath).put(`/pratica/${uuid}/update-step/15`).catch(() => {});
        dispatch(sendRemainderEmail(uuid, apiPath));
    }

    function onUploadNow() {
        dispatch({type: actionTypes.STEP_SECONDARY_DOCUMENTS});
    }

    return (
        <div className={styleThankYou.ThankYouContainer}>
            <Logo />
            <div className={styleThankYou.Content}>
                <div className={styleThankYou.leftright}>
                    <div className={styleThankYou.left}>
                        {
                            (risultato === 'success' && type === 'primary') ? (
                                <>
                                    <h4>Abbiamo ricevuto correttamente i tuoi dati. </h4>
                                    <h1>La tua richiesta è quasi completa!</h1>
                                    <p>Ti ricordiamo che per completare la tua richiesta di finanziamento dovrai inviarci: </p>
                                    <ul>
                                        <li> <b>Tessera Sanitaria</b> </li>
                                        <li> <b>Documento di Reddito</b> <em>(l’ultima busta paga se sei un lavoratore dipendente, il cedolino della pensione se sei titolare di pensione, il modello unico se sei un lavoratore autonomo) </em></li>
                                    </ul>
                                    <div>
                                        <Button type='link' onClick={onSendRemainderEmail} className={styleThankYou.ButtonSecondary} loading={loadingConferma}>Invia i documenti in seguito</Button>
                                        <Button type='link' onClick={onUploadNow} className={styleThankYou.Button}>Carica subito i documenti</Button>
                                    </div>
                                </>
                            ) : (risultato === 'success' && type === 'secondary') ? (
                                <>
                                    <h4>Grazie per aver scelto Prestipay!</h4>
                                    <h1>La tua richiesta è ora in valutazione.</h1>
                                    <p>Ti abbiamo inviato una email con ulteriori dettagli sul completamento del processo. Se non hai ricevuto l'email, controlla la casella Spam.</p>
                                    <Button type='link' href={linkHome} className={styleThankYou.ButtonSecondaryPage}>Torna alla home</Button>
                                </>
                            ) : risultato === 'error' ? (
                                <>
                                    <h4>Ops!</h4>
                                    <h1>Siamo spiacenti, il link è scaduto</h1>
                                    <p>Se sei ancora interessato a un prestito online PrestiPay, inizia una nuova richiesta.</p>
                                    <Button type='link' href={linkPreventivatore} className={styleThankYou.Button}>Richiedi online</Button>
                                </>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ThankYou;